import styled from "styled-components";
import { Text, portalColors } from "src/components";


export const StyledText = styled(Text)`
    font-weight: ${ p => p.weight || 400 };
    color: ${ p => p.color || portalColors.text };
    text-align: left;
    font-size: ${ p => p.size };
    margin: ${ p => p.margin || "1px" };
    text-align: ${ p => p.align || "left"};
`;

export const Container = styled.div`
    height: calc(100vh - 135px);
    display: flex;
    flex-direction: column;
    flex-grow: 0;

    ::-webkit-scrollbar {
        width: 0.375rem;
        height: 0.5rem;
        border-radius: 0.375rem;
        border-right: none;
        border-left: none;
    }

    ::-webkit-scrollbar-thumb {
        background-color: var(--calendar-border-strong, #DBE5ED);
        border-radius: 0.375rem;
    }

    ::-webkit-scrollbar-track {
        background: ${portalColors.surfaceSoft};
        margin-left: 1.875rem;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceSoft};
        border-radius: 0.375rem;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceSoft};
        border-radius: 0.375rem;
    }
`;

export const StyledInput = styled.input`
    border: 1px solid ${portalColors.border};
    height: 42px;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    border-radius: 0.5rem;
    background-color: ${portalColors.surfaceSoft};
    color: ${portalColors.text};
    outline: none;
    width: 100%;
    text-align: left;
    padding: 0 1.25rem;
    max-width: 21.5rem !important;
    box-sizing: border-box;

    ::placeholder {
        color: ${portalColors.textSoft};
        text-align: left;
        font-family: Manrope;
        font-weight: 700;
        font-size: 0.875rem;
    }
`;

export const ChatListScrollableContainer = styled.ul`
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 1rem;
    height: auto;

    ::-webkit-scrollbar {
        width: 0.375rem;
        height: 0.5rem;
        border-radius: 0.375rem;
        border-right: none;
        border-left: none;
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: var(--calendar-border-strong, #DBE5ED);
        border-radius: 0.375rem;
    }

    ::-webkit-scrollbar-track {
        background: ${portalColors.surfaceSoft};
        margin-left: 1.875rem;
        margin-top: 0.3125rem;
        margin-bottom: 12px;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceSoft};
        border-radius: 0.375rem;
        
    }

    ::-webkit-scrollbar-track-piece:end {
        background-color: ${portalColors.surfaceSoft};
        border-radius: 0.375rem;
    }
`;

export const CompanyLogoContainer = styled.div`
    width: 100%;
    height: 3.825rem;
    border-radius: 16px 16px 0 0;
    background-color: ${p => p.backgroundColor || portalColors.surfaceSoft};
    padding: 1rem 1rem;
    box-sizing: border-box;
    border-bottom: 1px solid ${portalColors.border};
`;

export const Icon = styled.img`
    height: ${p => p.height};
    width: ${p => p.width};
    color: ${p => p.color};
    cursor: pointer;
`;

export const CreateChatButtons = styled.button`
    background-color: ${p => p.isAllowed ? portalColors.actionPrimary : "var(--calendar-border-strong, #DBE5ED)"};
    height: 42px;
    width: 2.6875rem !important;
    border-radius: 0.5rem !important;
    text-align: center;
    padding: 0;
    box-sizing: border-box;
    border: 0;
    cursor: pointer;
    pointer-events: ${p => p.isAllowed ? "auto" : "none"};
    margin-left: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;
